/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var PficonTemplateIcon = createIcon({
  name: 'PficonTemplateIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M219.429 1024h146.286v-73.143h-146.286v73.143zM438.857 1024h146.286v-73.143h-146.286v73.143zM877.714 731.428v-292.571h-219.429v73.143h146.286v146.286h-146.286v73.143h219.429zM438.857 731.428h146.286v-73.143h-146.286v73.143zM365.714 658.286h-146.286v-219.429h-73.143v292.571h219.429v-73.143zM948.571 875.428h-873.143v-873.143h873.143v873.143zM994.126 948.571c16.503 0 29.874-13.371 29.874-29.874v-967.154c0-16.16-13.097-26.971-29.257-26.971h-964.411c-16.754 0-30.331 11.291-30.331 28.046v966.789c0 16.114 13.051 29.166 29.166 29.166h964.96zM219.429 146.286h146.286v-73.143h-146.286v73.143zM438.857 146.286h146.286v-73.143h-146.286v73.143zM877.714 365.714v-292.571h-219.429v73.143h146.286v146.286h-146.286v73.143h219.429zM438.857 365.714h146.286v-73.143h-146.286v73.143zM365.714 292.571h-146.286v-219.429h-73.143v292.571h219.429v-73.143z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
});

export default PficonTemplateIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/pficon-template-icon.js
// module id = 1217
// module chunks = 0